import React, { useState, useEffect } from 'react';
import { Settings, User, ChevronLeft, ChevronRight, Import } from 'lucide-react';
import './DashboardBase.css';
import { useNavigate } from "react-router";
import { UserMenu } from "../components/user-menu";
import { useAuth } from '../context/AuthContext';
import {ROLES} from "../config/routes";

const DashboardBase = ({page, content}) => {
  const navigate = useNavigate();

  const { isLoggedIn, userRole, login, logout } = useAuth();

  return (
    <div className="dashboard">
      {/* Top Navigation */}
      <div className="top-nav">
        <div className="nav-container">
          <div className="nav-content">
            <div className="logo">Laki</div>
            <div className="user-controls">
              <Settings className="icon" />
              {/* <User className="icon" /> */}
              <UserMenu />
            </div>
          </div>
        </div>
      </div>

      <div className="main-container">
        {/* Secondary Navigation */}
        <div className="secondary-nav">
          <button
            onClick={() => { navigate('/') }}
            className={page === 'home' ? ' nav-button active' : ' nav-button inactive'} >Dashboard</button>

          { userRole == ROLES.ADMIN || userRole == ROLES.FUND_MANAGER  ?
            <button
              onClick={() => { navigate('/funds') }}
              className={page === 'funds' ? ' nav-button active' : ' nav-button inactive'}>Money Market Funds</button>
          : <></>
          }

          { userRole == ROLES.ADMIN ?
             <>
                <button
                  onClick={() => { navigate('/fund-manager') }}
                  className={page === 'fund-manager' ? ' nav-button active' : ' nav-button inactive'}>Fund Manager</button>
                <button
                  onClick={() => { navigate('/users') }}
                  className={page === 'users' ? ' nav-button active' : ' nav-button inactive'}>Users</button>
                <button
                  onClick={() => { navigate('/kyc') }}
                  className={page === 'kyc' ? ' nav-button active' : ' nav-button inactive'}>KYC</button>
             </>
              : <></> 
          }
        { userRole == ROLES.ADMIN || userRole == ROLES.FUND_MANAGER  ?
          <button
            onClick={() => { navigate('/transaction') }}
            className={page === 'transactions' ? ' nav-button active' : ' nav-button inactive'}>Transaction</button>
        :
        <></>
        }
        </div>

        {content}

      </div>
    </div>
  );
};

export default DashboardBase;
